var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"topPage"}},[(_vm.nonuser && !_vm.isResetPage())?_c('NonUserTop',{on:{"set-uname":_vm.setUserName}}):_vm._e(),(_vm.user && !_vm.isResetPage())?_c('UserTop',{attrs:{"currentUname":_vm.currentUname}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }